import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

export default function SettingMain() {
    return (
        <Box>
            <Box
                sx={{
                    height: "500px",
                    backgroundImage: "url(/bg_images/solve_puzzle.jpeg)",
                    backgroundSize: "contain",
                    backgroundPosition: "center",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    color: "white",
                    fontSize: "24px",
                }}
            />
            <Typography variant="body1" sx={{ mt: 2, mb: 2 }}>
                Always think about what's best for the customer. Focus on fun and creativity.
            </Typography>
            <Typography variant="body1">Great ideas come all the time.</Typography>
        </Box>
    );
}
